import fetch from "./feche";

// 待办事项查询展会预约信息列表接口
export function getAgencyMattersList(data) {
    return fetch({
        url: "/mwhInvitationCustomerInfo/getAgencyMattersList",
        method: "get",
        params: data,
    });
}
